import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "search-results",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true"
}

import { computed } from 'vue';
import { INFO_CARD_COLOR } from '@constants/info-card-color';
import { TimetableResultsHeader } from '../../Atoms';
import { InfoCard, TimetableSailing, NoSailingsAvailable } from '../../Molecules';
import { timetableBackupUrl, umbracoBaseUrl } from '../../envVariables';

import { Sailing } from '../../types/Sailing';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableSearchResults',
  props: {
    sailings: {},
    isLoading: { type: Boolean },
    isError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const showResultsHeader = computed(() =>
  !props.isError
  && props.sailings
  && props.sailings.length > 0);

const showNoSailingsAvailable = computed(() =>
  !props.isLoading && !props.isError && (!props.sailings || props.sailings.length === 0));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showResultsHeader.value)
      ? (_openBlock(), _createBlock(_unref(TimetableResultsHeader), {
          key: 0,
          "arrival-text": _ctx.$t('Arrival'),
          "departure-text": _ctx.$t('Departure')
        }, null, 8, ["arrival-text", "departure-text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sailings, (sailing, index) => {
        return (_openBlock(), _createBlock(_unref(TimetableSailing), {
          key: index,
          "departure-time": sailing.departureTime,
          "arrival-time": sailing.arrivalTime,
          "is-cancelled": sailing.isCancelled,
          "is-delayed": sailing.isDelayed,
          "delayed-departure-time": sailing.delayedDepartureTime,
          "delayed-arrival-time": sailing.delayedArrivalTime,
          stops: sailing.stops,
          "view-stops-text": _ctx.$t('View stops'),
          "is-loading": _ctx.isLoading
        }, null, 8, ["departure-time", "arrival-time", "is-cancelled", "is-delayed", "delayed-departure-time", "delayed-arrival-time", "stops", "view-stops-text", "is-loading"]))
      }), 128)),
      (showNoSailingsAvailable.value)
        ? (_openBlock(), _createBlock(_unref(NoSailingsAvailable), {
            key: 0,
            text1: _ctx.$t('No sailings body 1'),
            text2: _ctx.$t('No sailings body 2'),
            "base-url": _unref(umbracoBaseUrl)
          }, null, 8, ["text1", "text2", "base-url"]))
        : _createCommentVNode("", true),
      (_ctx.isError)
        ? (_openBlock(), _createBlock(_unref(InfoCard), {
            key: 1,
            "icon-name": "warning",
            text: _ctx.$t('Trouble retrieving timetables'),
            "embedded-link": _unref(timetableBackupUrl),
            "embedded-link-text": 'here.',
            lg: true,
            "background-color": _unref(INFO_CARD_COLOR).white,
            "border-color": _unref(INFO_CARD_COLOR).red
          }, null, 8, ["text", "embedded-link", "background-color", "border-color"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})